import { Divider, HStack, Text, VStack } from "@chakra-ui/react";
import { TicketTypeValues } from "./schema";
import dayjs from "dayjs";
import DatepickerFormInput from "../DatepickerFormInput";

const TicketTypeTimeline = ({
  timezone,
  loading = false,
}: {
  timezone: string;
  loading: boolean;
}) => {
  return (
    <VStack w="full">
      <Text fontSize={"xl"} fontWeight={"bold"} align="left" w="full">
        Timeline
      </Text>
      <Divider />
      <HStack w="100%" spacing={8}>
        <DatepickerFormInput<TicketTypeValues>
          skipValidate
          method="onChange"
          label="On Sale Date (optional)"
          name="on_sale_at"
          deps={["off_sale_at", "start_at", "end_at"]}
          timezone={timezone}
          dateTimeProps={{
            disabled: loading,
            disablePast: false,
            slotProps: {
              actionBar: {
                actions: ["clear", "accept"],
              },
            },
          }}
        />
        <DatepickerFormInput<TicketTypeValues>
          method="onChange"
          skipValidate
          label="Off Sale Date (optional)"
          name="off_sale_at"
          timezone={timezone}
          deps={["on_sale_at", "start_at", "end_at"]}
          dateTimeProps={{
            disabled: loading,
            disablePast: true,
            slotProps: {
              actionBar: {
                actions: ["clear", "accept"],
              },
            },
          }}
        />
      </HStack>
      <HStack w="100%" spacing={8}>
        <DatepickerFormInput<TicketTypeValues>
          skipValidate
          method="onChange"
          label="Valid From Date (optional)"
          name="start_at"
          timezone={timezone}
          dateTimeProps={{
            disablePast: true,
            disabled: loading,
            slotProps: {
              actionBar: {
                actions: ["clear", "accept"],
              },
            },
          }}
        />
        <DatepickerFormInput<TicketTypeValues>
          skipValidate
          label="Valid to Date (optional)"
          name="end_at"
          method="onChange"
          timezone={timezone}
          dateTimeProps={{
            disabled: loading,
            disablePast: true,
            slotProps: {
              actionBar: {
                actions: ["clear", "accept"],
              },
            },
          }}
        />
      </HStack>
    </VStack>
  );
};

export default TicketTypeTimeline;
